// extracted by mini-css-extract-plugin
export var container = "_ac-0";
export var error = "_ac-9";
export var label = "_ac-5";
export var light = "_ac-6";
export var md = "_ac-3";
export var sm = "_ac-2";
export var thin = "_ac-8";
export var thinBold = "_ac-7";
export var vertical = "_ac-4";
export var xs = "_ac-1";